import { render, staticRenderFns } from "./TagFetch.vue?vue&type=template&id=379c0266"
import script from "./TagFetch.vue?vue&type=script&lang=js"
export * from "./TagFetch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports